export const searchBadge = {
  'search-badge': {
    width: "100%",
    padding: "3px",
    borderRadius: 4
  }
};
      